var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"justify":"center","dir":"ltr"}},[_c('v-date-picker',{attrs:{"color":"rgba(232, 241, 247, 0.72)","width":"100%"},model:{value:(_vm.picker),callback:function ($$v) {_vm.picker=$$v},expression:"picker"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }